import {
  ExternalLink,
  Facebook,
  Globe2,
  Instagram,
  Linkedin,
  Send,
  type LucideIcon,
} from "lucide-react";
import { socialLinks, type SocialLinkId } from "../data/socialLinks";
import { triggerHaptic } from "../lib/telegram";

const socialIcons: Record<SocialLinkId, LucideIcon> = {
  instagram: Instagram,
  telegram: Send,
  linkedin: Linkedin,
  facebook: Facebook,
  website: Globe2,
};

export function SocialLinks({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`social-links ${compact ? "social-links--compact" : ""}`}>
      {socialLinks.map((link) => {
        const Icon = socialIcons[link.id];

        return (
          <a
            key={link.id}
            className="social-link"
            href={link.href}
            target="_blank"
            rel="noreferrer"
            aria-label={`Открыть ${link.label}: ${link.handle}`}
            onClick={() => triggerHaptic("open")}
          >
            <span className="social-link__icon">
              <Icon size={compact ? 17 : 21} strokeWidth={1.8} aria-hidden="true" />
            </span>
            <span className="social-link__copy">
              <strong>{link.label}</strong>
              {!compact && <small>{link.handle}</small>}
            </span>
            {!compact && <ExternalLink size={16} strokeWidth={1.8} aria-hidden="true" />}
          </a>
        );
      })}
    </div>
  );
}
